import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation teams($id: ID!) {
  deleteTeam(id: $id){
    id
  }
}`;

function deleteTeam(id) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
    },
  }).then((res) => res.data.deleteTeam);
}

export default deleteTeam;
